import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'modelsOfPractice',
    label: 'Models of Practice',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
